import { useSelector } from 'react-redux';
import { hooks } from '@lifesize/clients.sdk';

// TODO - Move to SDK if other apps need it? - A hook composed of other existing hooks
export default function useIsLocalAudioMuted(): boolean {
  return useSelector((state) => {
    const media = hooks.useMedia();
    return !!media?.localAudioMuted;
  });
}
